/* eslint-disable class-methods-use-this */
import axios from "axios";

import {
  API_ELASTICSEARCH_URL,
  API_ITEM_URL,
  API_LIST_SKU_STORAGE_URL,
  API_STOCK_URL,
  COMMON_HEADER_CONFIG
} from "../config";

class ItemManagementService {
  getAccessToken = () => localStorage.getItem("accessToken");

  searchItem = (params = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_LIST_SKU_STORAGE_URL}/search`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          size: 10,
          page: 1,
          ...params
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  searchPrdInStationBySku = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_ELASTICSEARCH_URL}/list-sku/autocomplete-sku`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      return axios(config)
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  searchItemBySkuElastic = (params = {}, data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_ELASTICSEARCH_URL}/list-sku/search`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          size: 10,
          page: 1,
          ...params
        },
        data: {
          item_available: data.item_available,
          sku: params.sku.normalize("NFC"),
          station_id: data.station_id
        }
      };
      if (data.item_active) {
        config.data.item_active = true;
      }
      if (data.station_id) {
        config.data.station_id = data.station_id;
      }
      return axios(config)
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  searchItemElastic = (params = {}, data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_ELASTICSEARCH_URL}/list-sku/search`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          size: 10,
          page: 1,
          ...params
        },
        data: {
          all_query: params.all_query.normalize("NFC"),
          item_available: data.item_available
          // station_id: data.station_id,
        }
      };
      if (data.item_active) {
        config.data.item_active = true;
      }
      if (data.station_id) {
        config.data.station_id = data.station_id;
      }
      return axios(config)
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getItems = (params = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ITEM_URL}/items`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          size: 1000,
          page: 1,
          ...params
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getItem = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ITEM_URL}/item/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createItem = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_ITEM_URL}/item`,
        data: dataCreate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateItem = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = JSON.stringify(data);
      const config = {
        method: "put",
        url: `${API_ITEM_URL}/item/${data.id}`,
        data: dataUpdate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getItemsByBarcode = (params = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_STOCK_URL}/stock-process/stock-by-sku-barcode`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          ...params
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const itemManagementService = new ItemManagementService();

export default itemManagementService;
